<script setup lang="ts">
/**
 * @author Beka Chkhaidze
 */
import { computed } from "vue";
import { ImageType } from "@/store/main/types/component/UI";
import type { ComplexComponentItem } from "../smartComponents/ComplexComponent/ts/Content.interface";
const Picture = defineAsyncComponent(
  () => import("@/components/regularComponents/UIComponents/Picture.vue")
);

const props = defineProps<{
  content: ComplexComponentItem;
}>();

const data = computed(() => props.content?.data as ImageType[]);
</script>

<template>
  {{}}
  <div class="picture-cover">
    <Picture
      v-for="(item, index) in data"
      :key="index"
      :devices="item.devices"
      alt="image"
      imgClass="img-absolute"
    />
  </div>
</template>

<style lang="scss">
.picture-cover {
  position: relative;
  height: auto;
  font-size: 0;
  overflow: hidden;
  padding-top: calc(100% / (1200 / 551));
}
</style>
